import React from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { availableOptionsX, BAR_CHART_DATASET_TYPES } from './utils/index.js';

function DatasetSelect({ selectedX, selectedDataset, onSelect }) {
  return (
    <div className="flex">
      <div className="text-muted m-r-16">Dataset</div>
      <ButtonToolbar style={{ width: '190px' }}>
        <DropdownButton
          id="data-type"
          bsStyle="info"
          title={
            BAR_CHART_DATASET_TYPES.find(
              (type) => type.value === selectedDataset
            ).name
          }
          className="btn-block text-capitalize"
          onSelect={(val) => onSelect({ dataset: val })}
          pullRight
        >
          {availableOptionsX[selectedX].map((type, index) => (
            <MenuItem
              key={index}
              active={type.value === selectedDataset}
              eventKey={type.value}
            >
              {type.name}
            </MenuItem>
          ))}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default DatasetSelect;
